import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { RegEntidadAuditoraViewModel, RegCampaniaEntidadAuditoraViewModel, RegTecnicoEntidadAuditoraViewModel } from './entidadauditora.types';
import { EntidadAuditoraService } from './entidadauditora.service';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ConfirmationService } from 'primeng/api';
import { OnInit } from '@angular/core';
import { UsuarioViewModel } from '../../usuarios/usuarios.types';

@Component({
    selector: 'app-entidadauditora-edit',
    templateUrl: './entidadauditora-edit.component.html',
})
export class EntidadAuditoraEditComponent extends ComponentBase implements OnInit {
    /** nombrescientificos-edit ctor */

    editMode: boolean;
    editTitle = 'Nueva';
    listProvincia: Tc[];
    entidadAuditora: RegEntidadAuditoraViewModel;
    usuarioTecnicoEA: UsuarioViewModel;
    visibilitySpinner = false;
    isCollapsedEntidad = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        private entidadAuditoraService: EntidadAuditoraService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.entidadAuditora = new RegEntidadAuditoraViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.entidadAuditoraService.getEntidadAuditora(id).subscribe(result => {
                this.entidadAuditora = result;
                this.updateForm();
            });
        }

        this.globalService.getProvincias().subscribe(res => {
            this.listProvincia = res;
        });
    }

    createForm() {
        this.form = this.fb.group({
            Id: null, //Not visible but required
            Nombre: ['', Validators.required],
            Apellidos: ['', Validators.required],
            NIF: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            RazonSocial: ['', Validators.required],
            NIFRazonSocial: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            IdProvinciaRazonSocial: [null, Validators.required],
            LocalidadRazonSocial: ['', Validators.required],
            DireccionRazonSocial: ['', Validators.required],
            CodigoPostalRazonSocial: ['', Validators.required],
            NombrePersonaContacto: ['', Validators.required],
            ApellidosPersonaContacto: ['', Validators.required],
            TelefonoPersonaContacto: ['', Validators.required],
            EmailPersonaContacto: ['', Validators.compose([Validators.required, CustomValidator.emailEmptyValidator])],
            Observaciones: '',
            Activa: true,
            FechaAlta: [{ value: '', disabled: true }],
            FechaBaja: [{ value: '', disabled: true }],
        });
    }

    updateForm() {
        this.form.setValue({
            Id: this.entidadAuditora.Id, //Not visible but required
            Nombre: this.entidadAuditora.Nombre,
            Apellidos: this.entidadAuditora.Apellidos,
            NIF: this.entidadAuditora.NIF,
            RazonSocial: this.entidadAuditora.RazonSocial,
            NIFRazonSocial: this.entidadAuditora.NIFRazonSocial,
            IdProvinciaRazonSocial: this.entidadAuditora.IdProvinciaRazonSocial,
            LocalidadRazonSocial: this.entidadAuditora.LocalidadRazonSocial,
            DireccionRazonSocial: this.entidadAuditora.DireccionRazonSocial,
            CodigoPostalRazonSocial: this.entidadAuditora.CodigoPostalRazonSocial,
            NombrePersonaContacto: this.entidadAuditora.NombrePersonaContacto,
            ApellidosPersonaContacto: this.entidadAuditora.ApellidosPersonaContacto,
            TelefonoPersonaContacto: this.entidadAuditora.TelefonoPersonaContacto,
            EmailPersonaContacto: this.entidadAuditora.EmailPersonaContacto,
            Observaciones: this.entidadAuditora.Observaciones,
            Activa: this.entidadAuditora.Activa,
            FechaAlta: new Date(this.entidadAuditora.FechaAlta),
            FechaBaja: this.entidadAuditora.FechaBaja != null ? new Date(this.entidadAuditora.FechaBaja) : '',
        });
    }

    onSave() {
        //si se desactiva la EA mostrar mensaje de confirmación
        if (!this.form.value.Activa) {
            this.confirmationService.confirm({
                message: 'Si desactiva la Entidad Auditora, se desactivarán sus campañas y técnicos asociados, ¿quiere continuar?',
                accept: () => {
                    //Actual logic to perform a confirmation
                    this.onSubmit();
                },
            });
        } else {
            this.onSubmit();
        }
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            this.isCollapsedEntidad = false;
            return;
        }

        this.visibilitySpinner = true;

        let entidadAuditora = new RegEntidadAuditoraViewModel();

        entidadAuditora.Id = this.entidadAuditora.Id; //Not visible but required
        entidadAuditora.Nombre = this.form.value.Nombre;
        entidadAuditora.Apellidos = this.form.value.Apellidos;
        entidadAuditora.NIF = this.form.value.NIF;
        entidadAuditora.NIFRazonSocial = this.form.value.NIFRazonSocial;
        entidadAuditora.RazonSocial = this.form.value.RazonSocial;
        entidadAuditora.DireccionRazonSocial = this.form.value.DireccionRazonSocial;
        entidadAuditora.CodigoPostalRazonSocial = this.form.value.CodigoPostalRazonSocial;
        entidadAuditora.LocalidadRazonSocial = this.form.value.LocalidadRazonSocial;
        entidadAuditora.IdProvinciaRazonSocial = this.form.value.IdProvinciaRazonSocial;
        entidadAuditora.NombrePersonaContacto = this.form.value.NombrePersonaContacto;
        entidadAuditora.TelefonoPersonaContacto = this.form.value.TelefonoPersonaContacto;
        entidadAuditora.ApellidosPersonaContacto = this.form.value.ApellidosPersonaContacto;
        entidadAuditora.EmailPersonaContacto = this.form.value.EmailPersonaContacto;
        entidadAuditora.Observaciones = this.form.value.Observaciones;
        entidadAuditora.Activa = this.form.value.Activa;

        if (this.editMode) {
            this.entidadAuditoraService.editEntidadAuditora(entidadAuditora).subscribe({
                next: () => {
                    this.addSuccessMessage('Entidad Auditora modificada correctamente');
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                },
            });
        } else {
            this.entidadAuditoraService.createEntidadAuditora(entidadAuditora).subscribe({
                next: () => {
                    this.addSuccessMessage('Entidad Auditora añadida correctamente');
                    this.visibilitySpinner = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onAddCampania() {
        this.router.navigate([this.router.url, 'campanias', 'create']);
    }

    onAddTecnico() {
        this.router.navigate([this.router.url, 'tecnicos', 'create']);
    }

    onEditCampania(item: RegCampaniaEntidadAuditoraViewModel) {
        this.router.navigate([this.router.url, 'campanias', 'edit', item.IdCampania]);
    }

    onEditTecnico(item: RegTecnicoEntidadAuditoraViewModel) {
        this.router.navigate([this.router.url, 'tecnicos', 'edit', item.IdUsuario]);
    }

    onDeleteTecnicoExistenteComoACyEA(item: RegTecnicoEntidadAuditoraViewModel) {
        this.entidadAuditoraService.getTecnico(item.IdUsuario).subscribe(result => {
            this.usuarioTecnicoEA = result;
        });

        this.confirmationService.confirm({
            message: '¿Está seguro de que quiere borrar el técnico autorizado a la Entidad Auditora?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.entidadAuditoraService.deleteTecnicoExistenteComoACyEA(this.usuarioTecnicoEA).subscribe({
                    next: () => {
                        this.addSuccessMessage('Técnico autorizado borrado correctamente');
                        this.ngOnInit();
                    },
                    error: () => this.addErrorMessage('Error al borrar el Técnico autorizado.'),
                });
            },
        });
    }

    onReactivateTecnicoExistenteComoACyEA(item: RegTecnicoEntidadAuditoraViewModel) {
        this.entidadAuditoraService.getTecnico(item.IdUsuario).subscribe(result => {
            this.usuarioTecnicoEA = result;
        });
        this.confirmationService.confirm({
            message: '¿Está seguro de que quiere reactivar el técnico autorizado a la Entidad Auditora?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.entidadAuditoraService.reactivateTecnicoExistenteComoACyEA(this.usuarioTecnicoEA).subscribe({
                    next: () => {
                        this.addSuccessMessage('Técnico autorizado reactivado correctamente');
                        this.ngOnInit();
                    },
                    error: () => this.addErrorMessage('Error al reactivar el Técnico autorizado.'),
                });
            },
        });
    }

    //onDeleteCampania(item: RegCampaniaEntidadAuditoraViewModel) {
    //    this.confirmationService.confirm({
    //        message: '¿Está seguro?',
    //        accept: () => {
    //            //Actual logic to perform a confirmation
    //            this.entidadAuditoraService.deleteCampania(item.IdRegEntidadAuditora, item.IdCampania).subscribe({
    //                next: () => {
    //                    this.addSuccessMessage('Campaña eliminada correctamente');
    //                    const index = this.entidadAuditora.TwRegCampaniaEntidadAuditoraCollection.findIndex(({ IdCampania }) => IdCampania === item.IdCampania);
    //                    this.entidadAuditora.TwRegCampaniaEntidadAuditoraCollection = this.entidadAuditora.TwRegCampaniaEntidadAuditoraCollection.filter(
    //                        (_, s) => s !== index,
    //                    );
    //                },
    //                error: error => this.addErrorMessage('Error al borrar la Campaña.'),
    //            });
    //        },
    //    });
    //}

    onBack() {
        this.router.navigate(['/mantenimiento/registros/entidadesauditoras']);
    }
}
